/* 🤖 this file was generated by svg-to-ts */
export const matIconSettingsInputAntenna: {
  name: 'settings-input-antenna';
  data: string;
} = {
  name: 'settings-input-antenna',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29a2.5 2.5 0 0 0-5 0c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2a9 9 0 0 1 18 0h2c0-6.07-4.93-11-11-11z"/></svg>`
};
